export enum VirtualFileTypes {
    Regular = 'Regular',
    Directory = 'Directory'
}